var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.245 0.473337L15 12.7214L2.75495 0.473337C2.12399 -0.157779 1.10418 -0.157779 0.473221 0.473337C-0.15774 1.10445 -0.15774 2.12451 0.473221 2.75563L12.7183 15.0037L0.473221 27.2444C-0.15774 27.8755 -0.15774 28.8955 0.473221 29.5267C1.10418 30.1578 2.12399 30.1578 2.75495 29.5267L15 17.2786L27.245 29.5267C27.876 30.1578 28.8958 30.1578 29.5268 29.5267C30.1577 28.8955 30.1577 27.8755 29.5268 27.2444L17.2817 15.0037L29.5268 2.75563C30.1577 2.12451 30.1577 1.10445 29.5268 0.473337C28.8958 -0.157779 27.876 -0.157779 27.245 0.473337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.cca8db158979207e208279a258094509.svg";
export { ForwardRef as ReactComponent };